import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import Loading from './components/Loading';
import { router } from './routes/index';
import { ToastProvider } from './components/Toast/ToastContext';

function App() {
  return (
    <React.StrictMode>
      <React.Suspense fallback={<Loading />}>
        <ToastProvider>
          <Provider store={store}>
            <RouterProvider router={router} />
          </Provider>
        </ToastProvider>
      </React.Suspense>
    </React.StrictMode>
  );
}

export default App;
